// additional libs
// import "./utils/lite-youtube-embed";

import "../scss/styles-edito.scss";

import { createComponent } from "@bigyouth/base";
import * as features from "./features/exports/edito";

Object.values(features).forEach(createComponent); 
